import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterCustomersList'
})
export class FilterPipeCustomer implements PipeTransform {
  transform(customers: any, term?: any): any {
    if (term === undefined) return customers;
    if (term === null) return customers;

    if (customers != null) {
      return customers.filter(function (customer) {
        if (customer.name != undefined)
          if (customer.name.toLowerCase().includes(term.toLowerCase()))
            return customer;
        if (customer.phone != undefined)
          if (customer.phone.toString().toLowerCase().includes(term.toLowerCase()))
            return customer;
        if (customer.business_name != undefined)
          if (customer.business_name.toString().toLowerCase().includes(term.toLowerCase()))
            return customer;
        if (customer.business_number != undefined)
          if (customer.business_number.toString().toLowerCase().includes(term.toLowerCase()))
            return customer;
        if (customer.address != undefined)
          if (customer.address.toString().toLowerCase().includes(term.toLowerCase()))
            return customer;
        if (customer.email != undefined)
          if (customer.email.toString().toLowerCase().includes(term.toLowerCase()))
            return customer;
      })
    }

  }
}



// WEBPACK FOOTER //
// ./src/pages/customers/filter.pipe.ts